export const LANGUAGE_KEY = 'scene-share-language';
const EXPIRY_KEY = LANGUAGE_KEY + '-expires';
const DAYS = 30;
export function readLanguagePreference(now = Date.now()) {
  try {
    const language = localStorage.getItem(LANGUAGE_KEY);
    const expires = Number(localStorage.getItem(EXPIRY_KEY));
    if (['de','en','es'].includes(language) && Number.isFinite(expires) && expires > now) return language;
    // Old preferences had no expiry: retire them rather than silently extending them.
    localStorage.removeItem(LANGUAGE_KEY); localStorage.removeItem(EXPIRY_KEY);
  } catch { /* Storage is optional. */ }
  return null;
}
export function saveLanguagePreference(language, now = Date.now()) {
  try { localStorage.setItem(LANGUAGE_KEY, language); localStorage.setItem(EXPIRY_KEY, String(now + DAYS * 86400000)); } catch { /* The selected language still works in memory. */ }
}
export function clearLanguagePreference() {
  try { localStorage.removeItem(LANGUAGE_KEY); localStorage.removeItem(EXPIRY_KEY); } catch { /* No storage access. */ }
}
